import React, { useEffect, useState } from "react";
import Chart from "chart.js/auto";
import styles from "./Recon.module.css"; // your CSS file

const Recon = () => {
  const [accountName, setAccountName] = useState('');
  const [currentDate, setCurrentDate] = useState('');

   const readData = async () => {
      try {
        const value = await localStorage.getItem('bankName');
        const value1 = await localStorage.getItem('cashbookDate');
        
  
        
       
        if (value !== null) {
          setAccountName(value);
        }
        if (value1 !== null) {
          setCurrentDate(value1);
          // console.log(value1, '388383');
        }
        
      } catch (e) {
        alert('Failed to fetch the input from storage');
      }
    };
  
    useEffect(() => {
      readData();
    }, []);

    // console.log(currentDate)

  useEffect(() => {
    const pieCanvas = document.getElementById("pieChart");
    const barCanvas = document.getElementById("barChart");
    const lineCanvas = document.getElementById("lineChart");

    // Helper: safely destroy chart if it already exists
    const destroyExistingChart = (canvas) => {
      const chart = Chart.getChart(canvas);
      if (chart) chart.destroy();
    };

    // Destroy any existing charts first
    destroyExistingChart(pieCanvas);
    destroyExistingChart(barCanvas);
    destroyExistingChart(lineCanvas);

    // === Pie Chart - Matched vs Unmatched ===
    new Chart(pieCanvas, {
      type: "doughnut",
      data: {
        labels: ["Matched", "Unmatched"],
        datasets: [
          {
            data: [85, 15],
            backgroundColor: ["#2ecc71", "#e74c3c"],
          },
        ],
      },
      options: {
        plugins: { legend: { position: "top" } },
      },
    });

    // === Bar Chart - Outstanding Items ===
    new Chart(barCanvas, {
      type: "bar",
      data: {
        labels: ["Cashbook vs Bank", "AP vs Ledger", "Receivables vs GL"],
        datasets: [
          {
            label: "Outstanding Items",
            data: [20, 10, 12],
            backgroundColor: "#f39c12",
          },
        ],
      },
      
      options: {
        plugins: { legend: { display: false } },
        scales: { y: { beginAtZero: true } },
      },
    });

    // === Line Chart - Reconciliation Trend ===
    new Chart(lineCanvas, {
      type: "line",
      data: {
        labels: ["Oct 10", "Oct 11", "Oct 12", "Oct 13", "Oct 14", "Oct 15"],
        datasets: [
          {
            label: "Completion %",
            data: [60, 65, 70, 75, 80, 85],
            borderColor: "#004aad",
            backgroundColor: "rgba(0,74,173,0.1)",
            fill: true,
            tension: 0.3,
          },
        ],
      },
      options: { scales: { y: { beginAtZero: true, max: 100 } } },
    });

    // Cleanup charts on unmount
    return () => {
      destroyExistingChart(pieCanvas);
      destroyExistingChart(barCanvas);
      destroyExistingChart(lineCanvas);
    };
  }, []);

   function formatDateToLastOfMonth(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth();

  // Get last day of the month
  const lastDay = new Date(year, month + 1, 0);

  // Format day with suffix (st, nd, rd, th)
  const day = lastDay.getDate();
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? "rd"
      : "th";

  // Format month name
  const monthName = lastDay.toLocaleString("default", { month: "long" });

  return `${day}${suffix} ${monthName}, ${year}`;
}

  return (
    <div className={styles.reconbody}>
      {/* <header>
        <img src={companyLogo} alt="Company Logo" />
        <h1>Gateway Mortgage Bank</h1>
        <p>Reconciliation Dashboard &amp; Summary Report — December 2024</p>
      </header> */}

      <div className={styles.container}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
    width: '100%',
    paddingTop: '50px',
    borderBottom: '2px solid #004aad',
    paddingBottom: '5px',
        }}>
          <h3 style={{
            color: '#004aad',
    fontSize: '16px',
          }}>Summary Overview</h3>
  <h3 style={{
    color: '#000000',
    fontSize: '16px',
    
  }}>Account Selected: {accountName}</h3>
  <h3 style={{
    color: '#000000',
    fontSize: '16px',
    
  }}>Current Date: {currentDate ? formatDateToLastOfMonth(currentDate) : ''}</h3>
</div>
        

        
<div style={{marginTop: 15}}/>
        {/* <div className={styles.sectiontitle}>Visual Insights</div> */}

        <div className={styles.chartgrid}>
          <div className={styles.chartbox}>
            {/* <h4>Matched vs Unmatched (%)</h4> */}
            <canvas id="pieChart"></canvas>
          </div>
          <div className={styles.Reactchartbox}>
            <h4>Outstanding Items by Account</h4>
            <canvas id="barChart"></canvas>
          </div>
          <div className={styles.chartboxes}>
            <h4>Reconciliation Trend</h4>
            <canvas id="lineChart"></canvas>
          </div>
        </div>
<div style={{marginTop: 25}}/>
        <div className={styles.kpicontainer}>
          <div className={styles.kpicard}>
            <h3>Matched Items</h3>
            <div className={styles.valuematched}>85%</div>
          </div>
          <div className={styles.kpicard}>
            <h3>Unmatched Items</h3>
            <div className={styles.valueunmatched}>15%</div>
          </div>
          <div className={styles.kpicard}>
            <h3>Outstanding Items</h3>
            <div className={styles.valueoutstanding}>42</div>
          </div>
          <div className={styles.kpicard}>
            <h3>Difference</h3>
            <div className={styles.value}>0.00</div>
          </div>
        </div>
<div style={{marginTop: 25}}/>
        <div className={styles.sectiontitle}>Detailed Reconciliation Summary</div>

        <table className={styles.tableRecon}>
          <tbody>
            <tr>
              <th colSpan="2">Ledger Balance</th>
              <td>-455,088,932.25</td>
            </tr>
            <tr className={styles.highlight}>
              <th rowSpan="2">Add:</th>
              <td>Outstanding Credits in Ledger</td>
              <td>2,464,036,060.63</td>
            </tr>
            <tr className={styles.highlight}>
              <td>Outstanding Credits in Statement</td>
              <td>205,801,773.80</td>
            </tr>
            <tr>
              <th colSpan="2">Total Additions</th>
              <td>2,669,837,834.43</td>
            </tr>
            <tr className={styles.highlight}>
              <th rowSpan="2">Less:</th>
              <td>Outstanding Debits in Ledger</td>
              <td>213,783,822.23</td>
            </tr>
            <tr className={styles.highlight}>
              <td>Outstanding Debits in Statement</td>
              <td>2,290,540,499.25</td>
            </tr>
            <tr>
              <th colSpan="2">Total Deductions</th>
              <td>2,504,324,321.48</td>
            </tr>
            <tr className={styles.highlight}>
              <th colSpan="2">Statement Balance</th>
              <td>-289,575,419.30</td>
            </tr>
            <tr className={styles.total}>
              <th colSpan="2">DIFFERENCE</th>
              <td>0.00</td>
            </tr>
          </tbody>
        </table>

        {/* <div className={styles.signatures}>
          <div className={styles.signbox}>
            Prepared By
            <br />
            <small>Date:</small>
          </div>
          <div className={styles.signbox}>
            Checked By
            <br />
            <small>Date:</small>
          </div>
          <div className={styles.signbox}>
            Approved By
            <br />
            <small>Date:</small>
          </div>
        </div> */}
      </div>

      {/* <footer>© 2025 Brookes Professional Services Limited</footer> */}
    </div>
  );
};

export default Recon;
